import gql from "graphql-tag";
import graphqlClient from "../../../apollo";

class ShortTermProvider {
  ApplyForecast(appJson) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation shortTerm($appJson: String!) {
          shortTerm(appJson: $appJson) {
            data
          }
        }
      `,
      variables: {
        appJson,
      },
    });
  }

  ApplyExportExcel(headers, data, headers2, data2) {
    return graphqlClient.mutate({
      mutation: gql`
        mutation exportExcel(
          $headers: [String]!
          $data: String!
          $headers2: [String]!
          $data2: String!
        ) {
          exportExcel(
            headers: $headers
            headers2: $headers2
            data: $data
            data2: $data2
          ) {
            url
          }
        }
      `,
      variables: {
        headers,
        data,
        headers2,
        data2,
      },
    });
  }

  getData(country) {
    return graphqlClient.query({
      query: gql`
        query shortTerm($country: String!) {
          shortTerm(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getDataResult(country) {
    return graphqlClient.query({
      query: gql`
        query shockSimulatorResult($country: String!) {
          shockSimulatorResult(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }

  getDataResultEndogenize(country) {
    return graphqlClient.query({
      query: gql`
        query shockSimulatorResultEndogenize($country: String!) {
          shockSimulatorResultEndogenize(filter: $country) {
            data
          }
        }
      `,
      variables: {
        country,
      },
    });
  }
}

export default new ShortTermProvider();
